<template>
  <div>
    <div class="banner">
      <div class="content">
        <div class="banner-title">门店管理定制</div>
        <div class="line" />
        <div class="desc">
          线下经营场景全覆盖，为企业提供一站式智能化升级方案
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="block-shop01">
      <div class="sk-block-title">
        <div class="title">门店全场景IOT解决方案</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/shop-pic-01.png" alt="">
      </div>
    </div>
    <div class="block-shop02">
      <div class="sk-block-title">
        <div class="title">门店多场景收银解决方案</div>
      </div>
      <div class="content-02">
        <div class="item-01">
          <div class="item-01-lf">
            <div class="title">零售小店解决方案</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">收银记账</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">库存管理</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">促销活动</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">报表分析</div>
          </div>
          <div class="item-01-img">
            <img src="@/assets/images/solution/shop-ad-01.png" alt="">
          </div>
        </div>
        <div class="item-01">
          <div class="item-01-lf">
            <div class="title">水果生鲜解决方案</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">称重收银</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">会员营销</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">称重码打印</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">数据报表</div>
          </div>
          <div class="item-01-img">
            <img src="@/assets/images/solution/shop-ad-02.png" alt="">
          </div>
        </div>
        <div class="item-01">
          <div class="item-01-lf">
            <div class="title">3C数码解决方案</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">串码管理</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">收银记账</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">移动盘点</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">促销活动</div>
          </div>
          <div class="item-01-img">
            <img src="@/assets/images/solution/shop-ad-03.png" alt="">
          </div>
        </div>
        <div class="item-01">
          <div class="item-01-lf">
            <div class="title">自助收银解决方案</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">AI识客监控</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">自助结算收银</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">商品电子标签</div>
            <div class="sub-title"><img src="@/assets/images/solution/shop-icon.png" alt="">缺货自动预警</div>
          </div>
          <div class="item-01-img">
            <img src="@/assets/images/solution/shop-ad-04.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-shop01">
      <div class="sk-block-title">
        <div class="title">让门店收银更简单、快捷</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/shop-pic-02.png" alt="">
      </div>
    </div>
    <div class="block-shop03">
      <div class="sk-block-title">
        <div class="title">产品介绍</div>
      </div>
      <div class="content-wrap">
        <div class="content-03">
          <div v-for="(item, index) in introList" :key="`introList_0${index+1}`" class="item-02">
            <img :src="require(`@/assets/images/solution/shop-icon-0${index+1}.png`)" alt="">
            <div class="title">{{ item.title }}</div>
            <div class="line" />
            <div class="sub-title">{{ item.subTitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-shop01">
      <div class="sk-block-title">
        <div class="title">定制流程</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/distribute-pic-04.png" alt="">
      </div>
    </div>
    <CarouselItem title="门店管理定制" />
    <ConsultForm info-sources="门店管理定制" title="我要定制" />
    <TryModal v-if="visible" :visible="visible" info-sources="门店管理定制" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.ShopCustom,
  name: 'ShopCustom',
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false,

      introList: [
        {
          title: '界面风格',
          subTitle: '界面简洁、清晰明了、重点突出'
        },
        {
          title: '操作交互',
          subTitle: '操作简单流畅、减少培训、任何操作3步内完成'
        },
        {
          title: '产品功能',
          subTitle: '尽量避免让用户提前维护基础数据、做到开机即用'
        },
        {
          title: '专机专用',
          subTitle: '专注进销存和经营管理'
        },
        {
          title: '搭配硬件',
          subTitle: '扫码枪、扫码盒子、打印机、POS机、钱箱'
        }
      ]
    }
  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  background: url("~@/assets/images/solution/shop_banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #28DAFB;
      margin: 16px 0 31px;
    }
    .desc {
      width: 484px;
      height: 101px;
      font-size: 22px;
      color: #FFFFFF;
      line-height: 38px;
    }
    .btn-wrap {
      .btn {
        width: 200px;
        height: 58px;
        line-height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
      }
    }
  }
}
.block-shop01 {
  background: #fff;
}
.block-shop02 {
  background: #F6FBFF;
}
.block-shop03 {
  background: #F9F9F9;
}
.content-01 {
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0 100px;
  text-align: center;
}
.content-02 {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .item-01 {
    width: 586px;
    background: #fff;
    color: #595961;
    font-size: 16px;
    padding: 30px 30px 20px 35px;
    display: flex;
    justify-content: space-between;
    text-align: left;
    margin-bottom: 28px;
    &:nth-child(2n) {
      margin-right: 0;
    }
    &-img {
      margin-top: 10px;
    }
    .title {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 30px;
    }
    .sub-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 10px;
      >img {
        margin-right: 10px;
      }
    }
  }
}
.content-wrap {
  padding: 45px 0;
  margin: 0 auto;
  width: 1200px;
}
.content-03 {
  padding: 30px 0;
  background: #fff;
  display: flex;
  .item-02 {
    border-right: 1px solid #E8E8E8;
    padding: 37px 21px 0;
    color: #8B8FA1;
    font-size: 14px;
    width: 240px;
    .title {
      color: #595961;
      font-size: 20px;
      font-weight: 500;
      margin-top: 42px;
    }
    .line {
      width: 32px;
      height: 3px;
      background: #3986FF;
      margin: 12px auto 16px;
    }
    &:last-child {
      border-right: none;
    }
  }
}
</style>
